import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { DashboardHeaderProps } from '../../types/dashboardV2';
import { ROUTES } from '../../constants/routes';
import { NotificationBell } from '../../components/features/NotificationBell/NotificationBell';
import { LanguageSwitcher } from '../../components/common/LanguageSwitcher/LanguageSwitcher';

const PROFILE_HREF = `/${ROUTES.DASHBOARD}/${ROUTES.DASH_PROFILE}`;

export const DashboardHeader = ({ title }: DashboardHeaderProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const onProfile = pathname.startsWith(PROFILE_HREF);

  return (
    <header className="dashboard-header">
      <div>
        <h1 className="header-title">{title}</h1>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <LanguageSwitcher />
        <NotificationBell />
        {/* The account: details, Telegram login codes and log out live there. */}
        <Link
          to={PROFILE_HREF}
          className={`header-profile-btn${onProfile ? ' active' : ''}`}
          title={t('dashboard.sidebar.profile')}
          aria-label={t('dashboard.sidebar.profile')}
          aria-current={onProfile ? 'page' : undefined}
        >
          <span className="material-symbols-outlined" aria-hidden="true">
            account_circle
          </span>
        </Link>
      </div>
    </header>
  );
};

export default DashboardHeader;
